import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Hero } from "@/components/Hero";
import { Features } from "@/components/Features";
import { Process } from "@/components/landing/Process";
import { Benefits } from "@/components/landing/Benefits";
import { Services } from "@/components/landing/Services";
import { Testimonials } from "@/components/landing/Testimonials";
import { FAQ } from "@/components/landing/FAQ";
import { WhyChooseUs } from "@/components/landing/WhyChooseUs";
import { Footer } from "@/components/Footer";

const Index = () => {
  const navigate = useNavigate();
  const { user, isAdmin } = useAuth();

  useEffect(() => {
    if (user) {
      // Redirect admin users to admin dashboard, regular users to client dashboard
      const redirectPath = isAdmin ? '/admin' : '/dashboard';
      navigate(redirectPath);
    }
  }, [user, isAdmin, navigate]);

  return (
    <div className="bg-[#1A1F2C]">
      <Hero />
      <Features />
      <Process />
      <Benefits />
      <Services />
      <Testimonials />
      <WhyChooseUs />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Index;